import axios from "axios";
import { BASE_URL } from "./api";

export async function getUsers(payload) {
  // console.log('getting companies', payload.token)
  // console.log(payload)
  return axios({
    method: "get",
    url: `${BASE_URL}/list_users${payload.endpoint}`,
    headers: {
      Authorization: `Token ${payload.token}`,
    },
  })
    .then((response) => {
      // console.log('getUsersByGroup', response)
      return {
        users: response.data,
        count: response.data.length,
      };
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function getAllUsersWithGroups(token) {
  return axios({
    method: "get",
    url: `${BASE_URL}/users?is_active=True`,
    headers: {
      Authorization: `Token ${token}`,
    },
  })
    .then((response) => {
      // console.log('getUsersByGroup', response)
      return response
    })
    .catch((error) => {
      return error
    });
}

export async function getFullUsers(token, queryParams) {
  return axios({
    method: "get",
    url: `${BASE_URL}/users/get_full_user_list${queryParams}`,
    headers: {
      Authorization: `Token ${token}`,
    },
  })
    .then((response) => {
      return response
    })
    .catch((error) => {
      console.log(error);
      return error
    });
}

export async function getUsersByGroup(payload) {
  // console.log('getting companies', payload.token)
  // console.log(payload)
  return axios({
    method: "get",
    url: `${BASE_URL}/${payload.endpoint}?group=${payload.group}`,
    headers: {
      Authorization: `Token ${payload.token}`,
    },
  })
    .then((response) => {
      // console.log('getUsersByGroup', response)
      return {
        users: response.data,
        count: response.data.length,
      };
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function getActiveAndInactiveUsersByGroup(payload) {
  // console.log('getting companies', payload.token)
  // console.log(payload)
  return axios({
    method: "get",
    url: `${BASE_URL}/${payload.endpoint}?active_and_inactive_group=${payload.group}`,
    headers: {
      Authorization: `Token ${payload.token}`,
    },
  })
    .then((response) => {
      console.log('getUsersByGroup', response)
      return {
        users: response.data,
        count: response.data.length,
      };
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function getUsersWithTasks(token) {
  // console.log('getting companies', .token)
  // console.log()
  return axios({
    method: "get",
    url: `${BASE_URL}/list_users?has_task=True`,
    headers: {
      Authorization: `Token ${token}`,
    },
  })
    .then((response) => {
      // console.log('getUsersByGroup', response)
      return {
        users: response.data,
        count: response.data.length,
      };
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function getAllUsers(token) {
  // console.log('getting companies', payload.token)
  // console.log(payload)
  return axios({
    method: "get",
    url: `${BASE_URL}/list_users/`,
    headers: {
      Authorization: `Token ${token}`,
    },
  })
    .then((response) => {
      // console.log('getUsersByGroup', response)
      return {
        users: response.data,
        count: response.data.length,
      };
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function getAllCampaignOwners(token) {
  // console.log('getting companies', payload.token)
  // console.log(payload)
  return axios({
    method: "get",
    url: `${BASE_URL}/list_users?owns_campaigns=True`,
    headers: {
      Authorization: `Token ${token}`,
    },
  })
    .then((response) => {
      // console.log('getUsersByGroup', response)
      return {
        users: response.data,
        count: response.data.length,
      };
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function updateUserCSVExportLimit(token, user_id, payload) {
  return axios({
    method: "put",
    url: `${BASE_URL}/users/${user_id}/edit_user_csv_export_limit/`,
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
    data: payload
  }).then((response) => {
    return response
  }).catch((error) => {
    console.log(error)
    return error
  })
}

export async function createUserCSVExportLimit(token, user_id, payload) {
  return axios({
    method: "post",
    url: `${BASE_URL}/users/${user_id}/add_user_csv_export_limit/`,
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
    data: payload
  }).then((response) => {
    return response
  }).catch((error) => {
    console.log(error)
    return error
  })
}

export async function updateUser(token, user_id, payload) {
  return axios({
    method: "patch",
    url: `${BASE_URL}/users/${user_id}/`,
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
    data: payload
  }).then((response) => {
    return response
  }).catch((error) => {
    console.log(error)
    return error
  })
}

export async function updateFullUser(token, user_id, payload) {
  return axios({
    method: "patch",
    url: `${BASE_URL}/users/${user_id}/update_user/`,
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
    data: payload
  }).then((response) => {
    return response
  }).catch((error) => {
    console.log(error)
    return error
  })
}

export async function deactivateUser(token, user_id) {
  return axios({
    method: "patch",
    url: `${BASE_URL}/users/${user_id}/deactivate_user/`,
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    }
  }).then((response) => {
    return response
  }).catch((error) => {
    console.log(error)
    return error
  })
}

export async function activateUser(token, user_id) {
  return axios({
    method: "patch",
    url: `${BASE_URL}/users/${user_id}/activate_user/`,
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    }
  }).then((response) => {
    return response
  }).catch((error) => {
    console.log(error)
    return error
  })
}

export async function createUserImages(token, formData) {
  console.log('createUserImage', token, formData)
  return axios({
    method: "post",
    url: `${BASE_URL}/user-images/`,
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "multipart/form-data",
    },
    data: formData
  }).then((response) => {
    return response
  }).catch((error) => {
    console.log(error)
    return error
  })
}

export async function getUserImagesByUserId(token, userId) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/user-images/?user=${userId}`,
        headers: {
            'Authorization': `Token ${token}`
        },
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    });
}
